import { createV3Queries } from "@query/utils/createV3Queries";
import { linkRequestsApi } from "@api";
import { queriesPayers } from "./queriesPayers";
import { queriesPayees } from "./queriesPayees";

export const queriesLinkRequests = createV3Queries(
  "linkRequestsApi",
  linkRequestsApi,
  {
    // Accepting a link request links the two accounts, so the payer and payee
    // lists must refresh alongside the link-request list this registry owns —
    // cross-resource deps the name-derived defaults can't infer.
    acceptLinkRequest: queries => ({
      dependencies: () => [
        queries.listPayerPayeeLinkRequests.queryKeyBase,
        queriesPayers.listPayers.queryKeyBase,
        queriesPayees.listPayees.queryKeyBase
      ]
    })
  }
);
